<template>
  <v-container
    class="material-form-container rounded elevation-3"
    fluid>
    <h2>
      {{ isEdit ? 'Edit Material' : 'New Material' }}
    </h2>
    <v-form
      ref="material-form"
      @submit.prevent="onSubmit()">
      <v-row>
        <v-col
          cols="12"
          md="6">
          <gw-drop-file
            v-model="formData.imageUrls"
            multiple
            need-compress
            class="material-drop-file"
            s3-path="/sketch-images"
            caption="คลิกเพื่อเพิ่มรูปภาพ"
            :limit="10"
            label-bold />
        </v-col>
        <v-col
          cols="12"
          md="6">
          <v-row class="mt-5">
            <v-col cols="6">
              <v-text-field
                v-model.trim="formData.sketchId"
                label="Sketch Id"
                hide-details
                outlined
                dense
                @input="toUpperCase(formData.sketchId, 'sketchId')" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model.trim="formData.name"
                label="Name *"
                hide-details
                outlined
                dense
                :rules="textBoxRules"
                @input="toUpperCase(formData.name, 'name')" />
            </v-col>
            <v-col cols="6">
              <v-combobox
                v-model.trim="formData.factory"
                :items="factory"
                label="Factory *"
                single
                outlined
                deletable-chips
                small-chips
                dense
                hide-details
                :rules="textBoxRules"
                class="uppercase"
                @input="toUpperCase(formData.factory, 'factory')" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model.trim="formData.color"
                label="Color"
                hide-details
                outlined
                dense
                @input="toUpperCase(formData.color, 'color')" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model.trim="formData.size"
                label="Size"
                hide-details
                outlined
                dense
                @input="toUpperCase(formData.size, 'size')" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model.trim="formData.material"
                label="Material"
                hide-details
                outlined
                dense
                @input="toUpperCase(formData.material, 'material')" />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model.trim="formData.collectionName"
                label="Collection"
                hide-details
                outlined
                dense
                @input="toUpperCase(formData.collectionName, 'collectionName')" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model.number="formData.unitPrice"
                type="number"
                label="Unit Price"
                hide-details
                outlined
                dense />
            </v-col>
            <v-col cols="6">
              <v-radio-group
                v-model.trim="formData.currency"
                label="Currency"
                row
                hide-details
                dense
                class="mt-1">
                <v-radio
                  label="บาท"
                  value="thb"
                  color="secondary" />
                <v-radio
                  label="หยวน"
                  value="cny"
                  color="secondary" />
                <v-radio
                  label="ดอลลาร์"
                  value="usd"
                  color="secondary" />
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model.trim="formData.note"
                label="Note"
                dense
                hide-details
                outlined />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          class="d-flex justify-center">
          <v-btn
            type="submit"
            color="success"
            :loading="loading">
            Submit
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import MaterialsProvider from '@/resources/MaterialsProvider'
import MaterialsFactoryProvider from '@/resources/MaterialsFactoryProvider'

const MaterialsService = new MaterialsProvider()
const MaterialsFactoryService = new MaterialsFactoryProvider()

export default {
  data () {
    return {
      loading: false,
      isEdit: false,
      factoryData: [],
      formData: {
        imageUrls: [],
        name: '',
        factory: '',
        color: '',
        size: '',
        material: '',
        unitPrice: 0,
        currency: 'thb',
        collectionName: '',
        note: '',
        status: 'active'
      },
      textBoxRules: [
        (v) => !!v || 'Field is require!'
      ],
      numberBoxRules: [
        (v) => v >= 0 || 'Please enter more than 0'
      ]
    }
  },
  computed: {
    factory: {
      get () {
      const results = this.factoryData.map((item) => item.name)
      return results
    },
    set (newVal) {
      const newValue = newVal[0] ? newVal[0].trim().toLowerCase() : ''
      this.formData.factory = newValue
    }
    }
  },
  mounted () {
    if (this.$route.params?.id) {
      this.isEdit = true
      this.getMaterial()
    }
    this.getMaterialFactory()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setLoading: 'Components/setLoading'
    }),
    async getMaterial () {
      try {
        this.loading = true
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'LOADING DATA...'
        })

        const { data } = await MaterialsService.getById(this.$route.params.id)
        this.formData = data
      } catch (error) {
        console.error('getMaterial', error)
        this.setSnackbar({
          value: true,
          message: `Error: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
        this.setLoading({ active: false })
      }
    },
    async getMaterialFactory () {
      try {
        this.loading = true
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'LOADING DATA...'
        })

        const { data } = await MaterialsFactoryService.getAll({ limit: 9999 })
        this.factoryData = data.results
      } catch (error) {
        console.error('getFabricFactory', error)
        this.setSnackbar({
          value: true,
          message: `Error: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
        this.setLoading({ active: false })
      }
    },
    async onSubmit () {
      try {
        this.loading = true
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'PROCESSING...'
        })

        const valid = await this.$refs['material-form'].validate()

        if (valid) {
          const { data: duplicated } = await MaterialsService.getNameExist(this.$route.params.id || null, this.formData.name)

          if (duplicated) {
            this.setSnackbar({
              value: true,
              message: 'Duplicated material name',
              type: 'error'
            })

            return
          }

          if (this.isEdit) {
            await MaterialsService.updateOne(this.$route.params.id, this.formData)

            this.setSnackbar({
              value: true,
              message: 'Update material success',
              type: 'success'
            })
          } else {
            await MaterialsService.createOne(this.formData)

            this.setSnackbar({
              value: true,
              message: 'Create material success',
              type: 'success'
            })
          }

          this.$router.push({ name: 'MaterialsList' })
        }
      } catch (error) {
        console.error('onSubmit', error)
        this.setSnackbar({
          value: true,
          message: `Error: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
        this.setLoading({ active: false })
      }
    },
    toUpperCase (val, key) {
      this.formData[key] = val.toUpperCase() || ''
    }
  }
}
</script>

<style scoped>
.material-form-container {
  background-color: white;
}
.cursor-pointer {
  cursor: pointer;
}
.material-drop-file .upload-file {
  height: 258px;
}
.uppercase input {
  text-transform: uppercase;
}
</style>
